function anchor(){
    document.querySelectorAll('a[href^="#"]:not([href="#"], [href^="#mm"], [id^="tab"])').forEach(anchor => {
        // не трогать ссылки с href="#", mmenu, внутри .nc6-toolbar (режим редактирования), ссылки с id начинающийся с tab
        if(!anchor.closest('.nc6-toolbar')){
            anchor.addEventListener('click', (e) => {
                const anchorHref = anchor.getAttribute('href');
                const el = document.querySelector(`[id='${anchorHref.slice(1)}']`);

                e.preventDefault();

                if(el){
                    el.scrollIntoView({
                        behavior: 'smooth'
                    });
                    history.pushState(null,null,window.location.pathname + window.location.search + anchorHref);
                }
            });
        }
    });
}
export default anchor;